import React, { useEffect, useState } from "react";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import ConfirmDialog from "../../components/popups/ConfirmDialog";
import { prefillPlanning, getPlanning } from "./planningSlice";
import { showErrorToast } from "../../app/utils/helpers";

export function PrefillModal(props) {

  const dispatch = useDispatch()

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
  const selectedDate = useSelector((state) => state.planning.selectedDate)
  const collabs = useSelector((state) => state.collabs.list);

  const handleFloatingButtonClick = (event) => {
    dispatch(prefillPlanning({
      id_team: selectedTeamsIds[0],
      month: new Date(selectedDate).getMonth(),
      year: new Date(selectedDate).getFullYear()
    })).then((response) => {
      if (response['payload']['responseData']['status'] == 1) {
        loadPlanning()
      }
      if (response['payload']['responseData']['status'] == 4) {
        showErrorToast(response['payload']['responseData']['message'])
      }
      if (response['payload']['responseError']) {
        showErrorToast()
    }
    })
    hide()
  }

  function loadPlanning(){
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) =>{
        array.push(current.id)
        return array
      }, [])
      dispatch(getPlanning({selectedTeamsIds, selectedCollabsIds}))
    }
  }

  function hide() {
    props.onHide()
  }

  return (
    <ConfirmDialog
      open={!!props.show}
      icon={AutoFixHighIcon}
      title={<Langs str='PREFILL' />}
      message={<Langs str='ARE_YOU_SURE_PREFILL' />}
      confirmLabel={<Langs str='YES' />}
      onConfirm={() => handleFloatingButtonClick()}
      onCancel={() => hide()}
    />
  );
}
